import {useNavigate, useParams} from 'react-router-dom'
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import React, {useEffect, useRef, useState} from "react"
import {getFieldErrorParams, getInputValue} from "../../../utils"
import AdminContainer from "../../../components/admin/AdminContainer"
import {Grid} from "@mui/material"
import {useGlobalContext} from "../../../contexts/global_context"
import {BACKEND_URL, BRAND_NAME} from "../../../data/config"
import MenuItem from "@mui/material/MenuItem";
import {Helmet} from "react-helmet";

const CategoryNotificationCreateUpdateAdminPage = () => {
  const navigate = useNavigate()
  let {uid} = useParams()
  let form = useRef()
  let {sendAjax} = useGlobalContext()
  let [fieldErrors, setFieldErrors] = useState({})

  let [categories, setCategories] = useState([])

  useEffect(() => {
    // load categories
    sendAjax({
      url: `${BACKEND_URL}/api/v1/pkg/admin/categories/`,
      method: 'get',
      data: {
        page_size: 1000,
      },
    }).then((r) => {
      if (r.data.status_code === 200) {
        setCategories(r.data.data.results)
      }
    })
  }, [])

  useEffect(() => {
    if (uid) {
      sendAjax({
        url: `${BACKEND_URL}/api/v1/notifications/admin/category-notifications/${uid}/`,
        method: 'get',
        data: {},
      }).then((r) => {
        if (r.data.status_code === 200) {
          let cn = r.data.data
          setFormValues({
            notification_type: cn.notification_type,
            message: cn.message,
            enabled: cn.enabled,
            categories: cn.categories || [],
          })
        }
      })
    }
  }, [uid])

  let [formValues, setFormValues] = useState({
    notification_type: 10,
    message: '',
    enabled: true,
    categories: [],
  })

  const afterSubmit = (r) => {
    if (r.data.status_code === 200) {
      navigate("/admin/notifications/category-notifications")
    } else if (r.data.status_code === 400) {
      setFieldErrors(r.data.data)
    }
  }

  const handleSubmit = () => {
    if (uid) {
      sendAjax({
        url: `${BACKEND_URL}/api/v1/notifications/admin/category-notifications/${uid}/`,
        method: 'put',
        data: formValues,
      }).then(afterSubmit)
    } else {
      sendAjax({
        url: `${BACKEND_URL}/api/v1/notifications/admin/category-notifications/`,
        method: 'post',
        data: formValues,
      }).then(afterSubmit)
    }
  }

  const handleChange = (event) => {
    setFormValues({...formValues, [event.target.name]: getInputValue(event.target)})
    setFieldErrors({})
  }

  return (
    <AdminContainer>
      <Helmet>
        <title>Category Notification - {BRAND_NAME}</title>
      </Helmet>
      <Box component={ValidatorForm} ref={form} onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={4}>
            <TextValidator
              select
              label="Status"
              name={'enabled'}
              variant={'outlined'}
              fullWidth={true}
              onChange={(e) => setFormValues({...formValues, enabled: e.target.value})}
              value={formValues.enabled}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem value={true}>Enabled</MenuItem>
              <MenuItem value={false}>Disabled</MenuItem>
            </TextValidator>
          </Grid>

          <Grid item xs={12} sm={12} md={4}>
            <TextValidator
              select
              label="Type"
              name={'notification_type'}
              variant={'outlined'}
              fullWidth={true}
              onChange={handleChange}
              value={formValues.notification_type}
              {...getFieldErrorParams(fieldErrors, 'notification_type')}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem value={10}>Success</MenuItem>
              <MenuItem value={20}>Danger</MenuItem>
              <MenuItem value={30}>Warning</MenuItem>
              <MenuItem value={40}>Primary</MenuItem>
            </TextValidator>
          </Grid>

          <Grid item xs={12} sm={12} md={4}>
            <TextValidator
              select
              label="Categories"
              name={'categories'}
              variant={'outlined'}
              fullWidth={true}
              {...getFieldErrorParams(fieldErrors, 'categories')}
              value={formValues.categories}
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                multiple: true,
                value: formValues.categories,
                onChange: handleChange,
                renderValue: (selected) => `${selected.length} selected`,
              }}
            >
              {categories.map((c) => (
                <MenuItem key={c.uid} value={c.uid}>{c.title}</MenuItem>
              ))}
            </TextValidator>
          </Grid>

          <Grid item xs={12}>
            <TextValidator
              label={'Message HTML'}
              placeholder={'<b>Some category-specific info</b>'}
              name={'message'}
              variant={'outlined'}
              fullWidth={true}
              multiline
              minRows={4}
              onChange={handleChange}
              value={formValues.message}
              {...getFieldErrorParams(fieldErrors, 'message')}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>

        <Button
          color={'primary'}
          type={'submit'}
          variant="contained"
          sx={{
            margin: '20px 0 20px 0',
          }}
        >
          Save
        </Button>
      </Box>
    </AdminContainer>
  )
}

export default CategoryNotificationCreateUpdateAdminPage
